import { SimSurveyDuration } from "../enumerations/sim-survey-duration"

export interface SimSurveyData {
	cycleDurationHours: number,
	surveyType: SimSurveyDuration,
	surveyDurationHours: number,
	cycles: number,
	originalCommsPlan:string
}